<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <v-tabs grow>
          <v-tabs-slider color="green" />

          <v-tab v-if="uiElements.includes('report_tab')" @click="reportMode = 'list'">
            Очет по формам
          </v-tab>

          <v-tab v-if="uiElements.includes('statistic_tab')" @click="reportMode = 'statistics'">
            Статистика
          </v-tab>
        </v-tabs>
      </v-card-title>

      <v-card-text>
        <v-form v-if="uiElements.length" ref="form" lazy-validation v-model="formRules.valid" class="mb-n1">
          <ReportFilters
            @load-report="loadReport"
            :with-excel="true"
            v-model="filters" 
          />
        </v-form>
      </v-card-text>
    </v-card>

    <FormList v-if="reportMode === 'list'" ref="list" />
    <FormStatistics v-if="reportMode === 'statistics'" ref="statistics" />

  </v-container>
</template>

<script>
import moment from 'moment';

import { mapActions, mapGetters } from 'vuex';
import { requiredRule } from '~/plugins/rules';

import ReportFilters from '~/components/pages/stat/elements/ReportFilters.vue';
import FormList from '~/components/pages/stat/forms/List.vue';
import FormStatistics from '~/components/pages/stat/forms/Statistics.vue';

export default {
  name: 'FormReport',
  components: {
    ReportFilters,
    FormList,
    FormStatistics,
  },

  data() {
    return {
      reportMode: '', //'list' | 'statistics'
      forms: [],
      formRules: {
        valid: false,
        required: requiredRule,
      },
      filters: {},
      uiElements: [],
    }
  },

  computed: {
    ...mapGetters({
      loading: 'shared/getLoading',
      formReport: 'form_report/report',
    }),

    payload() {
      let payload = window.structuredClone(this.filters);
      payload.period = [
        moment(this.filters.period.start).format('YYYY-MM-DD HH:mm:ss'),
        moment(this.filters.period.end).format('YYYY-MM-DD HH:mm:ss')
      ];

      return payload;
    },
  },

  methods: {
    ...mapActions({
      resetAllState: 'resetAllState',
      getUIElements: 'shared/getUIElements'
    }),

    async loadReport(excel) {
      if (this.$refs.form.validate()) {
        if (excel) this.payload.excel = true;
        else delete(this.payload.excel);

        await this.$refs[this.reportMode].loadReport(this.payload);
      }
    },
  },

  async mounted() {
    this.uiElements = await this.getUIElements({routeName: this.$route.name})

    if (this.uiElements.includes('report_tab')) {
      this.reportMode = 'list'
    } else if (this.uiElements.includes('statistic_tab')) {
      this.reportMode = 'statistics'
    }
  },

  beforeDestroy() {
    this.resetAllState();
  },
}
</script>

<style scoped></style>
